// Workstream: Growth and marketing pages (landing, SEO pages, event host kit).
// Add this workstream's pages here; main.tsx renders every entry.
import { installAnalytics } from '../../lib/analytics';
import type { AppRoute } from '../../routes';
import { EventsPage } from './EventsPage';
import { BabyShowerPage, DesiPartyPage, DiwaliPage, EidPage, FamilyZoomPage, SangeetPage } from './SeoPages';

// main.tsx imports this module once at startup, which makes it the one place to switch on
// page-view tracking and client error reporting for the whole app.
installAnalytics();

export const routes: AppRoute[] = [
  { path: '/events', element: <EventsPage /> },
  { path: '/diwali-party-games', element: <DiwaliPage /> },
  { path: '/sangeet-games', element: <SangeetPage /> },
  { path: '/family-zoom-games', element: <FamilyZoomPage /> },
  { path: '/desi-party-games', element: <DesiPartyPage /> },
  { path: '/eid-party-games', element: <EidPage /> },
  { path: '/baby-shower-games-desi', element: <BabyShowerPage /> },
];
